import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// formik components
import { Formik, Form } from "formik";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import StorageManager from "helpers/StorageManager";

// Images
import image1 from "assets/images/prichard/bg_1.webp";
import image2 from "assets/images/prichard/bg_2.webp";
import image3 from "assets/images/prichard/bg_3.webp";
import { actions } from "store/reducers/authentication";
import validations from "./schemas/validations";
import formSchema from "./schemas/form";
import initialValues from "./schemas/initialValues";
import LoginForm from "./LoginForm";

function Basic() {
  const dispatch = useDispatch();
  const { validationErrors } = useSelector((state) => state.forms);
  const { formId, formField } = formSchema;
  const images = {
    1: image1,
    2: image2,
    3: image3,
  };
  const [bgImgInd, setBgImgSrc] = useState(null);

  useEffect(() => {
    let ind = StorageManager.get("LOGIN_BG_INDEX");
    if (typeof ind !== "string" || !ind) {
      ind = "1";
    }
    const bgIndex = parseInt(ind, 10);
    setBgImgSrc(bgIndex);
    StorageManager.set("LOGIN_BG_INDEX", bgIndex === 3 ? 1 : bgIndex + 1);
  }, []);
  const submitForm = async (values) => {
    if (!validationErrors) {
      const onSuccess = () => dispatch(actions.requestLogin(values));
      onSuccess();
    }
  };
  return (
    <BasicLayout image={bgImgInd && images[bgImgInd] ? images[bgImgInd] : ""}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <Formik
            initialValues={initialValues}
            validationSchema={validations}
            onSubmit={submitForm}
          >
            {({ values, errors, touched, isSubmitting }) => (
              <Form id={formId} autoComplete="new-password">
                <MDBox>
                  <LoginForm
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <MDBox mt={4} mb={1}>
                    <MDButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="info"
                      fullWidth
                    >
                      sign in
                    </MDButton>
                  </MDBox>
                </MDBox>
              </Form>
            )}
          </Formik>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
